import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// @material-ui/icons
import Face from '@material-ui/icons/Face';
import AddAlert from '@material-ui/icons/AddAlert';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import CustomAutoComplete from 'components/CustomInput/CustomAutoComplete';
import Snackbar from 'components/Snackbar/Snackbar';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';

// others
import { Context } from 'context/Context';
import FormHOC from 'hoc/FormHOC';
import detailsPageStyle from 'views/Common/style/detailsPageStyle';
import config from 'config';

class StudentRegister extends React.Component {
  state = {
    colleges: [],
    isModalOpen: false,
    college: {},
  };

  componentDidMount() {
    this.fetchColleges();
  }

  componentWillUnmount() {
    this.props.context.closeSnackbar();
  }

  fetchColleges = () => {
    axios
      .get(`${config.API_URL}/public/colleges/modified`)
      .then((response) => {
        this.setState({ colleges: response.data });
      })
      .catch(() => {
        this.props.context.handleSnackbar({
          status: 'danger',
          message: 'Problème serveur pour obtenir les colleges !',
        });
      });
  };

  checkCollege = () => {
    const { college, handleOnSubmit } = this.props;
    const validations = ['college'];

    if (!handleOnSubmit(validations)) return null;

    if (college.typeRep === '' || college.typeRep === 'non') {
      return this.props.history.push({
        pathname: '/auth/eleve-non-rep',
      });
    } else {
      return this.props.history.push({
        pathname: '/auth/eleve-rep',
        state: {
          ...this.props.location.state,
          college: this.state.college,
        },
      });
    }
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  };

  render() {
    const {
      classes,
      // inputs
      collegeAutoComplete,
      collegeState,
      // function
      handleOnChange,
      handleOnSelect,
    } = this.props;
    const {
      closeSnackbar,
      state: { snackbar },
    } = this.props.context;

    const content = (
      <div className={classes.topMargin}>
        <CustomAutoComplete
          success={collegeState === 'success'}
          error={collegeState === 'error'}
          formControlProps={{
            fullWidth: true,
          }}
          labelText={<span>Tape ici le nom de ton collège et sélectionne-le dans la liste :</span>}
          value={collegeAutoComplete || ''}
          data={this.state.colleges}
          handleChange={(event) => {
            handleOnChange(event.target.value, 'college', 'autocomplete');
          }}
          handleSelect={(name, infos) => {
            this.setState({ college: { name, infos } });
            handleOnSelect(name, infos, 'college');
          }}
        />
        <Button
          color='primaryNoBackground'
          customClass={classes.buttonFlat}
          onClick={() =>
            this.props.history.push({
              pathname: '/auth/eleve-non-rep',
            })
          }>
          Je ne trouve pas mon collège
        </Button>
      </div>
    );

    const footer = (
      <Button color='primary' onClick={this.checkCollege}>
        Continuer l&apos;inscription
      </Button>
    );

    const snackbarContainer = snackbar && snackbar.isSnackbar && (
      <Snackbar
        key='snackbar'
        place='bc'
        color={snackbar.status}
        icon={AddAlert}
        message={snackbar.message}
        open={true}
        closeNotification={closeSnackbar}
        close
      />
    );

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          {snackbarContainer}
          <GridContainer justifyContent='center'>
            <ItemGrid xs={12} sm={6} md={5} lg={4}>
              <form>
                <IconCard
                  icon={Face}
                  iconColor='red'
                  title='Inscription élève'
                  content={content}
                  footer={footer}
                  footerAlign='center'
                />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

StudentRegister.propTypes = {
  context: PropTypes.object.isRequired,
  clearInput: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  college: PropTypes.object,
  collegeAutoComplete: PropTypes.string,
  collegeState: PropTypes.string,
};

const WrappedComponent = FormHOC(StudentRegister);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
